export default __webpack_public_path__ + "static/media/linkedin.7eb01d96.webp";